import { Box, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { Orders } from '@hellohair/types';
import { useStyles } from '../../theme/styles.helpers';
import { SurveyStyles } from './Survey.Styles';
import SurveyImageUploads from './SurveyImageUploads';

interface SurveyProps {
  assets: Orders.SurveyAsset[];
  qanda: Orders.SurveyAnswer[];
}

const EXCLUDED_TYPES = ['UploadImages', 'Finish', 'Welcome', 'Interstitial'];

export const Survey: FC<SurveyProps> = ({ qanda, assets }) => {
  const styles = useStyles(SurveyStyles, {});
  const [open, setOpen] = useState(false);

  const filteredQanda = qanda.filter((q) => !EXCLUDED_TYPES.includes(q.type));

  return (
    <>
      <Box sx={styles.fragebogenRow} onClick={() => setOpen((prev) => !prev)}>
        <Typography sx={styles.fragebogenRowText}>Fragebogen</Typography>
        <Typography sx={styles.fragebogenArrow}>{open ? '▴' : '▾'}</Typography>
      </Box>

      {open && (
        <Box sx={styles.fragebogenContent}>
          {filteredQanda.map((q, i) => (
            <Box key={i} sx={styles.fragebogenItem}>
              <Typography sx={styles.fragebogenQuestion}>{q.question}</Typography>
              <Typography sx={styles.fragebogenAnswer}>{Orders.formatSurveyAnswer(q.answer)}</Typography>
            </Box>
          ))}

          <SurveyImageUploads images={assets.filter((f) => f.category == 'IMAGE')} />
        </Box>
      )}
    </>
  );
};
